
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.638 5.305a1 1 0 010 1.79l-8.747 4.353V.952l8.747 4.353z","fill":"#56BFC7"}}),_c('path',{attrs:{"stroke":"#56BFC7","stroke-width":"2","stroke-linecap":"round","d":"M1.815 1.141v15.718"}})])
          )
        }
      }
    